import { render, staticRenderFns } from "./CustomSkeletonLoader.vue?vue&type=template&id=7791ed86&scoped=true"
import script from "./CustomSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CustomSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7791ed86",
  null
  
)

export default component.exports